import { useEffect, useState } from 'react';

import api from '../../services/api';
import { useVendor } from '../VendorPovider/VendorPovider';

import type { CnpAuthor } from '@vgtv/api-client/lib/cnp_authors';

export function useAuthorsGet({ authorIds }: { authorIds?: string }) {
  const [authors, setAuthors] = useState<CnpAuthor[]>([]);
  const [areAuthorsFetching, setAreAuthorsFetching] = useState(true);
  const { vendor } = useVendor();

  useEffect(() => {
    (async () => {
      try {
        if (!authorIds) {
          setAuthors([]);
          setAreAuthorsFetching(false);
          return;
        }
        const ids = JSON.parse(authorIds);
        const authors = await api.getAuthors({
          ids,
          vendor,
        });

        setAuthors(authors.authors);
        setAreAuthorsFetching(false);
      } catch (err) {
        setAreAuthorsFetching(false);
        if (err instanceof Error && err.name === 'AbortError') {
          return;
        }
        console.error(err);
      }
    })();
  }, [authorIds, vendor]);

  return {
    authors,
    areAuthorsFetching,
  };
}
